export default __webpack_public_path__ + "static/media/arrowRed.6fa3aaf9.svg";